import { Menu, Tag } from 'antd';
const { SubMenu } = Menu;

export const renderActionMenuItems = menuItems => {
	return menuItems
		.filter(item => item !== null && item !== undefined)
		.map((option, indx) => {
			if (!option.submenu) {
				return (
					<Menu.Item
						title={option.tooltipText}
						disabled={option.disabled}
						onClick={e => {
							e.domEvent.stopPropagation();
							option.action(e);
						}}
						className="py-2"
						key={option.key || indx}
						style={{ width: '100%' }}
					>
						<div className="d-flex align-items-center">
							<span style={{ display: 'inline-block', fontSize: '1.3rem', marginRight: '5px' }}>
								{option.icon}
							</span>
							<span {...(option.props || {})}>{option.name}</span>
							{option.tags && option.tags.length
								? option.tags.map(tag => (
										<Tag color={tag.bgColor} className="ms-3">
											<span style={{ color: tag.textColor, fontSize: '11px' }}>{tag.text}</span>
										</Tag>
								  ))
								: null}
						</div>
					</Menu.Item>
				);
			} else {
				return (
					<SubMenu
						style={{ width: 'fit-content' }}
						key={option.key}
						onTitleClick={e => e.domEvent.stopPropagation()}
						title={
							<div className="d-flex align-items-center">
								<span style={{ display: 'inline-block', fontSize: '1.3rem', marginRight: '5px' }}>
									{option.icon}
								</span>
								<span>{option.name}</span>
							</div>
						}
					>
						{renderActionMenuItems(option.submenu)}
					</SubMenu>
				);
			}
		});
};
